/* eslint-disable import/no-anonymous-default-export */
export default (allAdvice = [], action) => {
  switch (action.type) {
    case "GET_ALL_ADVICE_DATA":
      return action.payload;
    default:
      return allAdvice;
  }
};
